import SearchHistoryResponse from '../../../common/response/SearchHistoryResponse'

class searchCache {
	static updateCache(key: string | null, query: string, url: string, isbn: string | null = null): void {
        if (key == null) {
            return
        }

        const historiesCache = localStorage.getItem(key)
        const historiesCacheParsed = historiesCache != null ? JSON.parse(historiesCache) : []

        const currentQuery: SearchHistoryResponse = {
            id: 0,
            query: query,
            date: new Date(),
            url: url,
            imageUrl: '',
            isbn: isbn,
        }

        localStorage.setItem(key, JSON.stringify([currentQuery, ...historiesCacheParsed]))
	}
}

export default searchCache